export default "__VITE_ASSET__DSy0KQ7O__"